import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import "./styles.less";

export const DeveloperBanner = (props) => {
  const { t } = useTranslation();
  const {
    title = `${t("developer.banner.title")}`,
    sub = `${t("developer.banner.subtitle")}`,
  } = props;

  const navList = [
    { key: "sso", label: t("developer.nav.sso") },
    { key: "use", label: `${t("developer.nav.use")}` },
    { key: "sdk", label: `${t("developer.nav.sdk")}` },
    { key: "authoriz", label: `${t("developer.nav.authorize")}` },
    { key: "security", label: `${t("developer.nav.security")}` },
    { key: "thirdLogin", label: `${t("developer.nav.thirdLogin")}` },
    { key: "formLogin", label: `${t("developer.nav.formLogin")}` },
    { key: "scanLogin", label: `${t("developer.nav.scanLogin")}` },
    { key: "practice", label: `${t("developer.nav.practice")}` },
    { key: "other", label: `${t("developer.nav.other")}` },
  ];

  const [type, setType] = useState(navList[0].key);

  const handleScroll = (id) => {
    setType(id);
    const el = document.querySelector(`#${id}`);
    el && el.scrollIntoView();
  };

  useEffect(() => {
    const scrollItems = navList.map((item) => {
      return document.querySelector(`#${item.key}`);
    });

    const scrollHandler = () => {
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        if (
          document.documentElement.scrollTop + 60 >=
          scrollItems[i].offsetTop
        ) {
          // setType(navList[i].key);
          break;
        }
      }
    };

    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, [navList]);

  return (
    <div>
      <section className="developer-banner">
        <div className="developer-banner-warp">
          <div className="solution-banner">
            <div className="banner-text">
              <div className="title">{title}</div>
              <div className="subtitle">{sub}</div>
            </div>
          </div>
        </div>

        <div className="developer-type">
          {navList.map((nav) => {
            const cls = classnames({
              item: true,
              selected: type === nav.key,
            });
            return (
              <span
                onClick={() => {
                  handleScroll(nav.key);
                }}
              >
                <div className={cls}>
                  {/* <div className="item-icon">
                  <i className={nav.icon}></i>
                </div> */}
                  {nav.label}
                </div>
              </span>
            );
          })}
        </div>
      </section>
    </div>
  );
};
